import { useState, useRef } from "react";
// import Overview from "../Overview/Overview";
import HydroForecast from "../HydrologicalForecast/Forecast";
import Forecast from "../GeoGlowsForecast/Forecast";
import FFGS from "../FFGS/FFGS";
import Inundation from "../FloodInundation/Inundation";
import "../../Cyclone/DisturbanceTrack/DisturbanceTrack.css";

const DashboardTabs = () => {
    const [activeSection, setActiveSection] = useState("hydroforecast");
    const [showLegend] = useState(true);
    // const overviewRef = useRef(null);
    const hydroforecastRef = useRef(null);
    const forecastRef = useRef(null);
    const ffgsRef = useRef(null);
    const inundationRef = useRef(null);

    const tabs = [
        // { id: "overview", label: "Overview" },
        { id: "hydroforecast", label: "Hydrological Forecast" },
        { id: "forecast", label: "Geoglows Forecast" },
        { id: "ffgs", label: "Flash Flood" },
        { id: "inundation", label: "Flood Inundation" }
    ];

    return (
        <div style={{ marginBottom: "1rem" }}>
            <div className="section-buttons-container" style={{ border: "0px" }}>
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        className={`section-button ${activeSection === tab.id ? 'active' : ''}`}
                        onClick={() => setActiveSection(tab.id)}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            <div className="section-content-container">
                {/* <div
          ref={overviewRef}
          className={`section-container ${activeSection === "overview" ? "active-section" : "hidden-section"}`}
        >
          <Overview />
        </div> */}
                <div
                    ref={hydroforecastRef}
                    className={`section-container ${activeSection === "hydroforecast" ? "active-section" : "hidden-section"}`}
                >
                    <HydroForecast showLegend={showLegend} />
                </div>
                <div
                    ref={forecastRef}
                    className={`section-container ${activeSection === "forecast" ? "active-section" : "hidden-section"}`}
                >
                    <Forecast showLegend={showLegend} />
                </div>

                <div
                    ref={ffgsRef}
                    className={`section-container ${activeSection === "ffgs" ? "active-section" : "hidden-section"}`}
                >
                    <FFGS showLegend={showLegend} />
                </div>
                <div
                    ref={inundationRef}
                    className={`section-container ${activeSection === "inundation" ? "active-section" : "hidden-section"}`}
                >
                    <Inundation showLegend={showLegend} />
                </div>

                {/* <div
          ref={intersectionRef}
          className={`section-container ${activeSection === "intersection" ? "active-section" : "hidden-section"}`}
        >
          <Intersection />
        </div> */}
            </div>
        </div>
    );
};

export default DashboardTabs;
